exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__input___3z_ua {\n  color: #3f3f3f !important;\n  font-weight: 600; }\n  .style__input___3z_ua::placeholder {\n    color: #828282;\n    font-weight: 500; }\n\n.style__menuWrapper___1m7Wh {\n  position: relative;\n  height: 54px; }\n\n.style__menu___3z_Os {\n  position: absolute;\n  top: 56px;\n  left: 0;\n  right: 0;\n  z-index: 5;\n  overflow: auto;\n  height: fit-content;\n  max-height: 200px; }\n\n.style__locationOption___38Aoz {\n  text-align: start;\n  display: flex;\n  padding: 0 !important; }\n  .style__locationOption___38Aoz > span {\n    height: 100%;\n    width: 100%;\n    padding-left: 17px; }\n", ""]);

// exports
exports.locals = {
	"input": "style__input___3z_ua",
	"menuWrapper": "style__menuWrapper___1m7Wh",
	"menu": "style__menu___3z_Os",
	"locationOption": "style__locationOption___38Aoz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SearchInputLocation/style.scss
// module id = 4203
// module chunks = 6